import { Component } from '@angular/core';
import {CoreService} from "../../services/core.service";
import {Router} from "@angular/router";
import {environment} from "../../../../environments/environment";

const env = environment.production;

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.sass']
})
export class IndexComponent {

  constructor(
    public coreServices: CoreService,
    public router: Router,
  ) {
  }

  ngOnInit() {
    if (env) {
      this.router.navigate(['/404']);
    }
  }


}
